export default {
  install() {
    /**
     * Étend Array avec la méthode when().
     *
     * @template T
     * @param {boolean} condition       Condition à tester.
     * @param {function(Array<T>): Array<T>} fn
     *   Fonction qui reçoit le tableau (this) et retourne son traitement si la condition est vraie.
     * @returns {Array<T>}              Le tableau original (si condition = false) ou le résultat de fn(this).
     */
    if (!Array.prototype.when) {
      Object.defineProperty(Array.prototype, 'when', {
        value(condition, fn) {
          return condition ? fn(this) : this
        },
        writable: true,
        configurable: true
      })
    }
  }
}
